import React, { useState, useEffect } from "react";
import StudentList from "../../components/StudentList";
import StudentInfo from "../../components/StudentInfo";
import EditStudentModal from "../../components/EditStudentModal";
import Dialog from "../../components/Dialog/Dialog";

const Students = () => {
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [dialog, setDialog] = useState({
    isOpen: false,
    type: "",
    title: "",
    message: "",
  });

  useEffect(() => {
    // Mockup class data
    const mockClasses = [
      { class_name: "Nursery" },
      { class_name: "KG" },
      { class_name: "Grade 1" },
    ];
    setClasses(mockClasses);

    // Mockup student data
    const mockStudents = [
      {
        studentId: "S001",
        name: "Aarav Thapa",
        className: "Nursery",
        age: 4,
        guardian: "Kiran Thapa",
        contact: "9800000001",
      },
      {
        studentId: "S002",
        name: "Sita Sharma",
        className: "KG",
        age: 5,
        guardian: "Manoj Sharma",
        contact: "9800000002",
      },
      {
        studentId: "S003",
        name: "Bikash Lama",
        className: "Grade 1",
        age: 6,
        guardian: "Saraswati Lama",
        contact: "9800000003",
      },
    ];
    setStudents(mockStudents);
  }, []);

  const handleSelectStudent = (student) => {
    setSelectedStudent(student);
  };

  const refreshStudentList = () => {
    // Normally you'd refetch, but with mock data we just log for now
    console.log("Mock: Student list refreshed");
  };

  const handleDeleteStudent = (studentId) => {
    setStudents((prev) => prev.filter((s) => s.studentId !== studentId));
    setSelectedStudent(null);
    setDialog({
      isOpen: true,
      type: "success",
      title: "Success",
      message: "Student deleted successfully (mock)",
      onConfirm: () => setDialog({ isOpen: false }),
    });
  };

  const handleEditComplete = (updatedStudent) => {
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student.studentId === updatedStudent.studentId
          ? updatedStudent
          : student
      )
    );
    setSelectedStudent(updatedStudent);
    setIsEditing(false);
    setDialog({
      isOpen: true,
      type: "success",
      title: "Success",
      message: "Student information updated (mock)",
      onConfirm: () => setDialog({ isOpen: false }),
    });
  };

  return (
    <div className="students-page">
      <StudentList
        students={students}
        onSelectStudent={handleSelectStudent}
        onStudentsFetched={setStudents}
      />
      <StudentInfo
        student={selectedStudent}
        onEdit={() => setIsEditing(true)}
        onDelete={() => handleDeleteStudent(selectedStudent.studentId)}
        onBack={() => setSelectedStudent(null)}
      />
      {isEditing && (
        <EditStudentModal
          student={selectedStudent}
          onSave={handleEditComplete}
          onCancel={() => setIsEditing(false)}
        />
      )}
      <Dialog
        isOpen={dialog.isOpen}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        onConfirm={dialog.onConfirm}
        onCancel={dialog.onCancel}
      />
    </div>
  );
};

export default Students;
